import { useState } from 'react';
import { useTheme } from 'styled-components';
import dynamic from 'next/dynamic';

import type { VerificationsProps } from 'components/PageWrappers/AdDetails/components/Verifications/Verifications.typed';
import type { VerificationModalProps } from 'components/PageWrappers/AdDetails/components/VerificationModal/VerificationModal.typed';

import {
  getVerificationDetails,
  getVerificationIconsAndText,
} from 'components/PageWrappers/AdDetails/components/Verifications/Verifications.helpers';
import * as Styled from 'components/PageWrappers/AdDetails/components/Verifications/Verifications.styled';

const VerificationModal = dynamic<VerificationModalProps>(
  () =>
    import(
      'components/PageWrappers/AdDetails/components/VerificationModal/VerificationModal'
    ).then((mod) => mod.VerificationModal),
  { ssr: false },
);

const Verifications = (props: VerificationsProps) => {
  const { verifications, showModal = true } = props;
  const theme = useTheme();
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);

  if (!verifications) return null;

  const { iconStatus, statusText } = getVerificationDetails(verifications);
  const verificationData = getVerificationIconsAndText(theme);
  const { icon, text } = verificationData[iconStatus];

  return (
    <>
      <Styled.Container>
        <span data-testid={`icon-${iconStatus}`}>{icon}</span>
        <Styled.VerificationText data-testid={`text-${iconStatus}`}>
          {showModal ? (
            <Styled.VerificationButton
              aria-haspopup="dialog"
              onClick={() => setIsVerificationModalOpen(true)}
            >
              {text}
            </Styled.VerificationButton>
          ) : (
            <>{text}</>
          )}
          &nbsp;{statusText}
        </Styled.VerificationText>
      </Styled.Container>
      {showModal && (
        <VerificationModal
          askToClose={() => setIsVerificationModalOpen(false)}
          isOpen={isVerificationModalOpen}
        />
      )}
    </>
  );
};

export { Verifications };
